// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 
import { IRemoteLogMessageSender } from "@lib/logging/IRemoteLogMessageSender";
import { NetworkSource } from "@lib/messaging/NetworkSource";

/**
 * Defines an API for creating an `IRemoteLogMessageSender` for a specific `NetworkSource`.
 */
export interface IRemoteLogMessageSenderFactory
{
  createRemoteLogMessageSender(networkSource: NetworkSource): IRemoteLogMessageSender;
}